import { cn } from '@/lib/utils';

interface CharacterCountProps {
  current: number;
  max: number;
  minimum?: number;
  className?: string;
}

export function CharacterCount({ current, max, minimum, className }: CharacterCountProps) {
  const isOverLimit = current > max;
  const isUnderMinimum = minimum !== undefined && current > 0 && current < minimum;

  return (
    <p
      className={cn(
        'mt-1 text-xs text-muted-foreground',
        (isOverLimit || isUnderMinimum) && 'text-destructive',
        className
      )}
    >
      {minimum !== undefined ? `${current}/${minimum} characters minimum. ` : null}
      {current}/{max} characters maximum
    </p>
  );
}
